/* global Swiper, postsHubData */

function initPostsCarousel(carousel) {
    return new Swiper(carousel, {
        effect: 'coverflow',
        loop: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
            rotate: 0,
            stretch: 30,
            depth: 100,
            scale: 0.5,
            modifier: 1,
            slideShadows: true,
        },
        navigation: {
            prevEl: carousel.querySelector('.swiper-button-prev'),
            nextEl: carousel.querySelector('.swiper-button-next'),
        },
    });
}

function fadeOut(el) {
    return el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 400, easing: 'ease', fill: 'forwards' }).finished;
}

function fadeIn(el) {
    return el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 400, easing: 'ease', fill: 'forwards' }).finished;
}

const hub = document.querySelector('.posts-hub');

if (hub && typeof postsHubData !== 'undefined') {
    const carouselEl = hub.querySelector('.posts-carousel.swiper-slider');
    const filterPills = hub.querySelectorAll('.filter-pill[data-category]');
    let swiperInstance = carouselEl ? initPostsCarousel(carouselEl) : null;

    async function fetchPosts(categorySlug) {
        let url = postsHubData.restUrl + '?per_page=100&orderby=date&order=desc&_embed=1';
        if (categorySlug && postsHubData.categories[categorySlug]) {
            url += '&categories=' + postsHubData.categories[categorySlug];
        }
        const res = await fetch(url);
        if (!res.ok) throw new Error('Failed to fetch posts');
        return res.json();
    }

    function buildSlideHTML(post) {
        const title = post.title.rendered;
        const link = post.link;
        let imgHTML;
        try {
            const media = post._embedded['wp:featuredmedia'][0];
            const sizes = media.media_details.sizes;
            const src = (sizes.large || sizes.full).source_url;
            imgHTML = `<img src="${src}" alt="${media.alt_text || ''}">`;
        } catch {
            imgHTML = `<img src="${postsHubData.placeholder}" alt="">`;
        }
        return `<div class="swiper-slide">
            <a href="${link}" class="slide-link">
                <div class="media-wrapper">
                    ${imgHTML}
                    <div class="slide-title"><h3>${title}</h3></div>
                </div>
            </a>
        </div>`;
    }

    async function filterPosts(categorySlug, targetHref) {
        try {
            const noPostsEl = hub.querySelector('.no-posts');
            const carousel = hub.querySelector('.posts-carousel.swiper-slider');
            const fadeTarget = carousel || noPostsEl;

            // Fetch while old content is still visible, then fade once data is ready
            const posts = await fetchPosts(categorySlug);
            if (fadeTarget) await fadeOut(fadeTarget);

            if (posts.length === 0) {
                if (swiperInstance) { swiperInstance.destroy(true, true); swiperInstance = null; }
                if (carousel) carousel.style.display = 'none';
                if (noPostsEl) {
                    noPostsEl.textContent = 'No posts found.';
                    noPostsEl.style.display = '';
                    await fadeIn(noPostsEl);
                }
            } else {
                if (noPostsEl) noPostsEl.style.display = 'none';

                let slides = [...posts];
                while (slides.length < 6) slides = [...slides, ...slides];

                if (swiperInstance) { swiperInstance.destroy(true, true); swiperInstance = null; }

                if (carousel) {
                    carousel.style.display = '';
                    carousel.querySelector('.swiper-wrapper').innerHTML = slides.map(buildSlideHTML).join('');
                    swiperInstance = initPostsCarousel(carousel);
                    await fadeIn(carousel);
                }
            }
        } catch (err) {
            console.error('Posts filter error:', err);
        }

        history.pushState({ category: categorySlug }, '', targetHref);
    }

    filterPills.forEach((pill) => {
        pill.addEventListener('click', (e) => {
            e.preventDefault();
            filterPills.forEach((p) => p.classList.remove('active'));
            pill.classList.add('active');
            filterPosts(pill.dataset.category, pill.href);
        });
    });
} else {
    // Fallback: initialize any carousels outside the posts-hub context
    document.querySelectorAll('.posts-carousel.swiper-slider').forEach((carousel) => {
        initPostsCarousel(carousel);
    });
}
